import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';

export default function SubjectDetailedInfo() {
  const rootElement = ReactDOM.createRoot(document.getElementById('root_element_subject_page'));

  rootElement.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}
